<template>
  <div v-if="config.visible" class="scanbox-overlay">
    <div class="scanbox-modal">
      <div class="scan-title">{{ config.label }}</div>

      <!-- 阶段 1：扫码 -->
      <div v-if="stage == 1" class="stage-box ">
        <div class="placeholder">
          <p v-if="config.status === 'waiting'">等待扫码</p>
          <p v-else-if="config.status === 'scanning'">扫码中…</p>
        </div>
      </div>

      <!-- 阶段 2：数字输入框 -->
      <div v-else-if="stage == 2" class="stage-box stage2">
        <p class="stage2-title">
          {{ config.details && config.details ? config.details : '未知' }}
        </p>
        <div class="stage2-number-box">
          <el-input-number
              v-model="config.value"
              :min="1"
              :max="config ? config.max : 1"
              @change="onNumberChange"
              class="stage2-input-number"
          />
        </div>
        <div class="stage2-input-number-tips">数量共({{ config.max }}张)</div>
      </div>

      <!-- 阶段 3：信息确认 -->
      <div v-else-if="stage == 3" class="stage-box stage3">
        <p class="stage3-title">
          {{ config.details && config.details ? config.details : '未知' }}
        </p>

        <!-- 券码列表 -->
        <div class="coupon-list" v-if="config.verifyCodeArr && config.verifyCodeArr.length">
          <div class="coupon-item" v-for="(code, index) in config.verifyCodeArr" :key="index">
            <span class="coupon-index">{{ index + 1 }}.</span>
            <span class="coupon-code">{{ code.receiptCode }}</span>
          </div>
        </div>

        <!-- 如果没有券码 -->
        <div v-else class="coupon-empty">暂无券码，请扫码</div>
      </div>

      <!-- 阶段 4：完成 -->
      <div v-else class="stage-box stage4">
        <div style="width: 50%" >
          <el-input placeholder="" v-model="config.peopleNum">
            <template #prepend>请输入玩家人数</template>
          </el-input>
        </div>
      </div>

      <!-- 底部关闭 -->
      <div class="footer-btns">
        <!-- 阶段3：左右按钮 -->
        <template v-if="stage == 3">
          <button class="left-btn" @click="goStage(1)">继续验券</button>
          <button class="right-btn" @click="finalSubmit">完成验券</button>
        </template>

        <!-- 阶段4：单个居中按钮 -->
        <template v-else-if="stage == 3">
          <button class="center-btn" @click="finalSubmit">确认</button>
        </template>
        <template v-else-if="stage == 2">
          <button class="left-btn" style="background: #67c23a;color: white" @click="submit">确认</button>
          <button class="right-btn" @click="close">关闭</button>
        </template>
        <!-- 阶段1/2：单个关闭按钮居右 -->
        <template v-else>
          <button class="close-btn" @click="close">关闭</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScanBoxDynamic",
  props: {
    config: {
      type: Object,
      required: true,
      default: function () {
        return {
          visible: false,
          stage1: {label: '扫码'},
          stage2: {value: 1, min: 1, max: 10, step: 1, label: '数量'},
          stage3: {label: '确认信息'},
          stage4: {label: '完成'}
        };
      }
    }
  },
  data: function () {
    return {
      stage: 1,
      buffer: "",
      lastKeyTime: 0,
      // increase maxInterval slightly to tolerate slower key event bursts from some environments
      maxInterval: 150,
      // safety cap for buffer length
      maxBufferLen: 512,
      scanResult: "",
      numValue: (this.config.value && this.config.value) ? this.config.value : 1
    };
  },
  computed: {},
  watch: {
    'config.visible': function (newVal) {
      if (newVal) {
        window.addEventListener("keydown", this.handleKeydown);
        this.resetState();
      } else {
        window.removeEventListener("keydown", this.handleKeydown);
      }
    },
  },
  methods: {
    resetState() {
      this.stage = 1;
      this.buffer = "";
      this.lastKeyTime = 0;
      this.scanResult = "";
      this.numValue = (this.config.value && this.config.value) ? this.config.value : 1
    },
    close() {
      if (this.stage === 1 || this.stage === 4 || this.stage === 2) {
        this.$emit("update:visible", false);
      } else {
        if (this.$message) {
          this.$message.warning("当前阶段无法关闭");
        }
      }
    },
    goStage(n) {
      this.stage = n;
    },
    //校验券码
    submit() {
      this.$emit("scanCheckCode");
    },
    //四阶段最终提交
    finalSubmit() {
      this.$emit("scanFinalSubmit");
    },
    onNumberChange(e) {
      this.config.value = e
    },
    handleKeydown(e) {
      // if dialog not visible, do nothing
      if (!this.config.visible) return;

      // ignore typing when user is focused on an input/textarea or contenteditable region
      try {
        const active = document && document.activeElement;
        if (active) {
          const tag = (active.tagName || '').toUpperCase();
          const isEditable = active.isContentEditable;
          if (tag === 'INPUT' || tag === 'TEXTAREA' || isEditable) {
            return; // let normal typing work
          }
        }
      } catch (err) {
        // ignore any DOM access errors and continue
      }

      const now = Date.now();

      // only process single-character keys or Enter
      if (e.key !== "Enter" && e.key.length !== 1) {
        return;
      }

      // Enter: treat as end of scan input
      if (e.key === "Enter") {
        if (this.buffer) {
          // finalize buffer and attempt to identify
          this.scanResult = this.buffer;
          this.buffer = "";
          const type = this.identifyCode(this.scanResult,this.config.type);
          if (type) {
            this.$emit("scanSuccess", { code: this.scanResult, type });
          } else {
            this.$emit("scanError", { code: this.scanResult });
            console.log('scanResult',this.scanResult)
            if (this.$message) {
              this.$message.error("不支持的二维码类型或券码格式");
            }
          }
        }
        return;
      }

      // if the time between keystrokes is too large, reset buffer (new scan / manual typing)
      if (now - this.lastKeyTime > this.maxInterval) {
        this.buffer = "";
      }

      // allow characters commonly present in codes and short URLs
      // letters, digits, underscore, hyphen, dot, colon, slash, query/hash chars, percent, plus, tilde
      const allowedChar = /^[A-Za-z0-9_\-\.:\/\?&=%+#~]$/;
      if (allowedChar.test(e.key)) {
        // append but cap buffer length
        if (this.buffer.length < this.maxBufferLen) {

          this.buffer += e.key;
        } else {
          // if buffer exceeds cap, drop it to prevent memory growth
          this.buffer = e.key;
        }
      }

      this.lastKeyTime = now;
    },
    identifyCode: (code, type) => {
      if (!code) return null;

      const text = String(code).trim();
      const normalizedType = String(type || '').trim().toLowerCase();

      if (
          (/^\d{10}$/.test(text) || /^\d{13}$/.test(text)) &&
          normalizedType === 'meituan'
      ) {
        return 'meituan';
      }

      // const douyinShortUrl = /https?:\/\/v\.douyin\.com\/(?:i)?[A-Za-z0-9]+\/?(?:\?.*)?/i;

      if (

          normalizedType == 'douyin'
      ) {
        return 'douyin';
      }

      return null;
    }
  }
};
</script>

<style scoped>
.scanbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1999;
}

.scanbox-modal {
  width: 450px;
  padding: 20px 28px;
  background: #fff;
  border-radius: 10px;
}

.scan-title {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}

.stage-box {
  text-align: center;
  padding: 20px 0;
}

.placeholder {
  color: #999;
  font-size: 22px;
}

.stage2-input-number-tips {
  margin-top: 20px;
}

.stage3-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  text-align: center;
}

.coupon-list {
  max-height: 200px; /* 超长列表滚动 */
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 12px;
  background: #f9f9f9;
}

.coupon-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  margin-bottom: 6px;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e6e6e6;
  font-size: 14px;
}

.coupon-item:last-child {
  margin-bottom: 0;
}

.coupon-index {
  font-weight: 600;
  color: #409eff;
  width: 24px;
}

.coupon-code {
  margin-left: 8px;
  word-break: break-all; /* 防止长码溢出 */
  flex: 1;
}

.coupon-empty {
  color: #999;
  font-size: 14px;
  text-align: center;
  padding: 20px 0;
}

.footer-btns {
  display: flex;
  margin-top: 20px;
  padding-top: 10px;
  align-items: center;
}

/* 阶段3左右按钮 */
.left-btn, .right-btn {
  flex: 1;
  padding: 8px 0;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.left-btn {
  margin-right: 10px;
  background: #f5f7fa;
  color: #606266;
}

.left-btn:hover {
  background: #e6e9ed;
}

.right-btn {
  background: #409eff;
  color: #fff;
}

.right-btn:hover {
  background: #66b1ff;
}

/* 阶段4居中按钮 */
.center-btn {
  margin: 0 auto;
  display: block;
  padding: 8px 20px;
  background: #67c23a;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.center-btn:hover {
  background: #85ce61;
}

/* 阶段1/2关闭按钮 */
.close-btn {
  margin-left: auto;
  padding: 8px 20px;
  background: #f56c6c;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.close-btn:hover {
  background: #f78989;
}
.stage4{
  display: flex;
  justify-content: center;
}

</style>
